var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex justify-center align-center"},[_c('div',{staticClass:"mt-1"},[_vm._v(" "+_vm._s(_vm.tableItem.active ? _vm.$t('notifications.list.yes') : _vm.$t('notifications.list.no'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }